import _get from 'lodash/get';
import { SCREEN_SAVER_DATA, SCREEN_SAVER_IS_LOCKED } from './screenSaver.constants';
import { getScreenSaverItemsData } from './screenSaver.utils';

export const initialState = {
  screenSaverData: null,
  isLocked: false,
};

export default (state = initialState, action) => {
  const screenSaverData = {
    section: _get(action.data, 'layout.section'),
    layoutId: _get(action.data, 'layout.id'),
    items: getScreenSaverItemsData(action.data),
  };

  switch (action.type) {
    case SCREEN_SAVER_DATA: {
      return {
        ...state,
        screenSaverData,
      };
    }
    case SCREEN_SAVER_IS_LOCKED: {
      return {
        ...state,
        isLocked: _get(action.data, 'isLocked'),
      };
    }
    default:
      return state;
  }
};
